import { code_send } from '../apis';

export default {
  namespaced: true,
  state: {
    smsError: false,
    smsErrorMessage: '',
    resendTime: 0,
    smsSendLoading: false,
    smsCode: 0,
  },
  mutations: {
    updateLoading(state, smsSendLoading) {
      state.smsSendLoading = smsSendLoading;
    },
    updateTime(state, time) {
      state.resendTime = time;
    },
    updateError(state, { smsError, smsErrorMessage, smsCode }) {
      state.smsError = smsError;
      state.smsErrorMessage = smsErrorMessage;
      state.smsCode = smsCode;
    },
  },
  actions: {
    /* 发送验证码 */
    async sms_code_send({ commit }, { phoneNumber, xd_client_id, risk }) {
      try {
        commit('updateError', {
          smsError: false,
          smsErrorMessage: '',
          smsCode: 0,
        });
        commit('updateTime', 0);
        commit('updateLoading', true);
        const body = { phoneNumber, xd_client_id };
        if (risk) {
          body.risk = risk;
        }
        const { data } = await code_send(body);
        commit('updateLoading', false);
        const { resendTime } = data;
        commit('updateTime', resendTime);
      } catch (error) {
        const { code, msg } = error;
        commit('updateLoading', false);
        commit('updateError', {
          smsError: true,
          smsErrorMessage: msg,
          smsCode: code,
        });
        console.error('ERROR:: sms_code_send', error);
      }
    },
  },
};
